import { render, staticRenderFns } from "./TutorialComponent.vue?vue&type=template&id=5795279c"
import script from "./TutorialComponent.vue?vue&type=script&lang=js"
export * from "./TutorialComponent.vue?vue&type=script&lang=js"
import style0 from "./TutorialComponent.vue?vue&type=style&index=0&id=5795279c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports